var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogueQualityManagement',{attrs:{"company-id":_vm.companyId}})
}
var staticRenderFns = []

export { render, staticRenderFns }